import React, { Component } from "react";
import { states } from "../../States/States";
import styles from "../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../components/calendar/Calendar";
import Icon from "../../../../components/icon/Icon";
import Button from "../../../../components/button/Button";
import Utils from "../../../../utils/Utils";
import OggettiUtili from "../../../../utils/OggettiUtili.json";
import { withTranslation } from "react-i18next";
import SegnalazioniService from "../../../../services/SegnalazioniServices";
import toasterConfig from "../../../../config/toasterConfig";
import history from "../../../../utils/History";
import ToasterSingleton from "../../../../singleton/ToasterSingleton";
import MalattieService from "../../../../services/MalattieService";
import Select from "../../../../components/select/Select";
import ButtonRow from "../../../../components/ButtonRow/ButtonRow";
import $ from "jquery";
import SessioneUtente from "../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../utils/Ruoli";
import Modale from "../../../../components/modale/Modale";
import Input from "../../../../components/textbox/Input";
import SelectAutocomplete from "../../../../components/selectAutocomplete/SelectAutocomplete";
import TableAllegatoTossinfezione from "./caricaAleggatoTossinfezione/TableAllegatoTossinfezione";
import globals from "../../../../config/appconfig";
import { format } from "date-fns";

const statiIstanza = require("../../../../dizionari/mappaInfoCliniche");
const infoEpidemiologicheMap = require("../../../../dizionari/mappaInfoEpidemiologiche");
const infoLaboratorioMap = require("../../../../dizionari/mappaInfoLaboratorio");
const tipoLaboratorioMap = require("../../../../dizionari/mappaTipoLaboratorio");

class InfoCliniche extends Component {
    state = {
        infoCliniche: {
            informazioniCliniche: "",
            listaDettaglioCli: [
                {
                    dettaglio: "",
                    sedeAnatomica: [""],
                    numeroLesioni: "",
                },
            ],
            note: "",
        },
        infoEpidemiologiche: {
            infoEpidemiologiche: "",
            listaDettaglioEpi: [""],
        },
        infoLaboratorio: {
            infoLaboratorio: "",
            listaDettaglioLab: [""],
            tipoLaboratorio: "",
            dataPrelievo: "",
            dataEsame: "",
        },
        clicksClinica: 0,
        clicksLaboratorio: 0,
        clicksEpidemiologico: 0,
        boxesClinica: [],
        boxesEpidem: [],
        boxesLab: [],
        listaInfoCliniche: [],
        listaInfoEpidemiologiche: [],
        listaInfoLaboratorio: [],
        defaultSelect: true,
        malattie: JSON.parse(sessionStorage.getItem("malattie")),
        malattiePremal: JSON.parse(sessionStorage.getItem("malattiePremal")),
        file: null,
        fileDaCaricare: null,
        fileCaricato: null,
        fileDaEliminare: null,
        autore:''
    };

    constructor(props) {
        super(props);
        this.setValoriCliniche = this.setValoriCliniche.bind(this);
        this.setValoriEpidemiologici = this.setValoriEpidemiologici.bind(this);
        this.setValoriLaboratorio = this.setValoriLaboratorio.bind(this);
        this.riceviValore = this.riceviValore.bind(this);
        this.riceviValoreCliniche = this.riceviValoreCliniche.bind(this);
        this.riceviValoreEpidemiologiche =
            this.riceviValoreEpidemiologiche.bind(this);
        this.riceviValoreLaboratorio = this.riceviValoreLaboratorio.bind(this);
        this.handleClickCliniche = this.handleClickCliniche.bind(this);
        this.handleClickLaboratorio = this.handleClickLaboratorio.bind(this);
        this.handleClickEpidemiologico =
            this.handleClickEpidemiologico.bind(this);
        this.aggiungiElementoClinica = this.aggiungiElementoClinica.bind(this);
        this.aggiungiElementoLaboratorio =
            this.aggiungiElementoLaboratorio.bind(this);
        this.aggiungElementoEpidemiologico =
            this.aggiungElementoEpidemiologico.bind(this);
        this._validate = this._validate.bind(this);
        this._back = this._back.bind(this);
        this.handleChangeInfoCliniche =
            this.handleChangeInfoCliniche.bind(this);
        this.handleChangeInfoLaboratorio =
            this.handleChangeInfoLaboratorio.bind(this);
        this.handleChangeInfoEpidemiologiche =
            this.handleChangeInfoEpidemiologiche.bind(this);
        this.handleChangeTipoLab = this.handleChangeTipoLab.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.controlloDatiToaster = this.controlloDatiToaster.bind(this);
        this.eliminaRowInfoCliniche = this.eliminaRowInfoCliniche.bind(this);
        this.eliminaRowInfoEpi = this.eliminaRowInfoEpi.bind(this);
        this.eliminaRowInfoLab = this.eliminaRowInfoLab.bind(this);
        this.riceviValoreNote = this.riceviValoreNote.bind(this);
        this.pulisciValori = this.pulisciValori.bind(this);
        this.setStatePadre = this.setStatePadre.bind(this);
        this.caricaPdf = this.caricaPdf.bind(this);
        this.updateFiles = this.updateFiles.bind(this);
        this.callToGetAllegati = this.callToGetAllegati.bind(this);
    }

    componentDidMount() {
        ToasterSingleton.instance().sottoscrizione(this);

        if(this.props.infoLaboratorio){
            let infoLab=this.state.infoLaboratorio;
            if(this.props.infoLaboratorio.infoLaboratorio)
                infoLab.infoLaboratorio=this.props.infoLaboratorio.infoLaboratorio;
            if(this.props.infoLaboratorio.tipoLaboratorio)
                infoLab.tipoLaboratorio=this.props.infoLaboratorio.tipoLaboratorio;
            if(this.props.infoLaboratorio.dataEsame)
                infoLab.dataEsame=this.props.infoLaboratorio.dataEsame;
            if(this.props.infoLaboratorio.dataPrelievo)
                infoLab.dataPrelievo=this.props.infoLaboratorio.dataPrelievo;
            if(this.props.infoLaboratorio.listaDettaglioLab)
                infoLab.listaDettaglioLab=this.props.infoLaboratorio.listaDettaglioLab;
            
            let inte=this.state.autore;

            if(this.props.infoLaboratorio.autore)
                inte=this.props.infoLaboratorio.autore;

            this.setState({infoLaboratorio: infoLab,autore: inte});
        }
        MalattieService.getInfoCliniche(this.props.datiPaziente.malattia)
            .then((data) => {
                let listaInfoCliniche = Utils.mapToArray(data.data);
                if (listaInfoCliniche.length === 0) {
                    let infoCliniche = this.state.infoCliniche;
                    infoCliniche.informazioniCliniche = "2";
                    this.setState({ infoCliniche: infoCliniche });
                } else {
                    this.setState({ listaInfoCliniche: listaInfoCliniche });
                }
                this.setValoriCliniche();
            })
            .catch(() => {
                this.setValoriCliniche();
                console.log("errore chiamata info cliniche");
            });
        MalattieService.getInfoEpidemiologiche(this.props.datiPaziente.malattia)
            .then((data) => {
                let listaInfoEpidemiologiche = Utils.mapToArray(data.data);
                if (listaInfoEpidemiologiche.length === 0) {
                    let infoEpidemiologiche = this.state.infoEpidemiologiche;
                    infoEpidemiologiche.infoEpidemiologiche = "2";
                    this.setState({ infoEpidemiologiche: infoEpidemiologiche });
                } else {
                    this.setState({
                        listaInfoEpidemiologiche: listaInfoEpidemiologiche,
                    });
                }
                this.setValoriEpidemiologici();
            })
            .catch(() => {
                this.setValoriEpidemiologici();
                console.log("errore chiamata info epidemiologiche");
            });
        MalattieService.getInfoLaboratorio(this.props.datiPaziente.malattia)
            .then((data) => {
                let listaInfoLaboratorio = Utils.mapToArray(data.data);
                if (listaInfoLaboratorio.length === 0) {
                    let infoLaboratorio = this.state.infoLaboratorio;
                    infoLaboratorio.infoLaboratorio = "2";
                    this.setState({ infoLaboratorio: infoLaboratorio });
                } else {
                    this.setState({
                        listaInfoLaboratorio: listaInfoLaboratorio,
                    });
                }
                this.setValoriLaboratorio();
            })
            .catch(() => {
                this.setValoriLaboratorio();
                console.log("errore chiamata info laboratorio");
            });
        this.callToGetAllegati();
    }

    callToGetAllegati() {
        if (
            this.props.segnalazioneCopia.idSegnalazione &&
            this.props.segnalazioneCopia.idPdf
        ) {
            SegnalazioniService.getAllegati(
                this.props.segnalazioneCopia.idSegnalazione
            )
                .then((res) => {
                    let file = res.data[0];
                    file.name = res.data[0].nome;
                    file.id = res.data[0].id;
                    file.stato = "modifica";
                    file.checked = true;
                    this.setState({ fileCaricato: file });
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.clicksClinica > this.state.clicksClinica) {
            this.handleClickCliniche();
        }
        if (prevState.clicksEpidemiologico > this.state.clicksEpidemiologico) {
            this.handleClickEpidemiologico();
        }
        if (prevState.clicksLaboratorio > this.state.clicksLaboratorio) {
            this.handleClickLaboratorio();
        }

        this.disabledDate();
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione();
        ToasterSingleton.instance().pulisci();
    }

    disabledDate() {
        let infoLaboratorio = this.state.listaInfoLaboratorio;
        if (
            infoLaboratorio.length <= 0 ||
            this.state.infoLaboratorio.infoLaboratorio === "2" ||
            (this.props.segnalazione && this.props.segnalazione.migrazione) ||
            SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Laboratorio.descrizione ||
            (this.props.segnalazioneCopia &&
                (this.props.segnalazioneCopia.statoSegnalazione ===
                    OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione ===
                        OggettiUtili.statoValidazioneByLabel.Validata.codice))
        ) {
            $(document).ready(function () {
                $("#dataPrelievo").datepicker("disable");
                $("#dataEsame").datepicker("disable");
            });
        } else {
            $(document).ready(function () {
                $("#dataPrelievo").datepicker("enable");
                $("#dataEsame").datepicker("enable");
            });
        }
    }

    _back() {
        // let prova=Utils.uniqueToaster(this.state.infoCliniche.listaDettaglioClinica)
        let path = "/ricercaSegnalazioni";
        history.push({ pathname: path });
    }

    async callToPutSegnalazione(statoSegnalazione) {
        let fileCaricatoList = [];
        let fileDaCaricareList = [];
        if (this.state.fileDaEliminare) {
            fileCaricatoList.push(this.state.fileDaEliminare);
        } else if (this.state.fileCaricato) {
            fileCaricatoList.push(this.state.fileCaricato);
        }
        if (this.state.fileDaCaricare) {
            fileDaCaricareList.push(this.state.fileDaCaricare);
        }
        let files = await Utils.getFiles(fileCaricatoList, fileDaCaricareList);
        let jsonInsert = this.props.segnalazione;
        jsonInsert["statoSegnalazione"] = statoSegnalazione;
        jsonInsert["esito"] = this.props.segnalazioneCopia.esito;
        jsonInsert["datiSpecifici"] =
            this.props.segnalazioneCopia.datiSpecifici;
        jsonInsert["files"] = files;

        if (this.state.malattiePremal["giornaliero"].includes(this.props.datiPaziente.malattia) || this.state.malattiePremal["settimanale"].includes(this.props.datiPaziente.malattia)) {
            jsonInsert["idoneitaPremal"] = Utils.retrieveIdoneitaPremal(
                this.props.segnalazioneCopia,
                this.props.datiPaziente,
                this.props.datiMedico
            );
        }

        let jsonInsertPulito = Utils.removeEmptyValueFromObject(jsonInsert);
        SegnalazioniService.putModificaSegnalazione(
            jsonInsertPulito,
            this.props.segnalazione.idSegnalazione,
            this.props.updateWizardState,
            this.props.segnalazione,
            this.props.showSpinner,
            this.updateFiles
        );
    }

    updateFiles(files) {
        let file = Array.isArray(files) ? files[0] : files;
        if (file) {
            file.checked = true;
            this.setState({ fileDaCaricare: null, fileCaricato: file });
        } else {
            this.setState({
                fileDaCaricare: null,
                fileCaricato: null,
                fileDaEliminare: null,
            });
        }
    }

    aggiungiToaster(text, textList, type) {
        ToasterSingleton.instance().aggiuntaToaster({
            type: type ? type : toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now(),
            textList: textList,
        });
    }

    nextStep(segnalazione, segnalazioneCopia) {
        let path = "/wizardSegnalazione";
        history.push({
            pathname: path,
            state: {
                currentState: states.ESITO,
                segnalazione: segnalazione,
                segnalazioneCopia: segnalazioneCopia,
                datiCompletiECorretti: Utils.getCompletezzaStep(segnalazione),
            },
        });
    }

    async callToConfermaInfo(statoSegnalazione) {
        let base64 = this.state.file
            ? await Utils.toBase64(this.state.file)
            : null;

        let file = base64
            ? {
                  nome: this.state.file.name ?? this.state.file.nome,
                  file: base64,
                  note: this.state.file.note,
                  data: this.state.file.data,
                  stato: this.state.file.stato,
              }
            : this.state.fileCaricato
            ? {
                  nome:
                      this.state.fileCaricato.name ??
                      this.state.fileCaricato.nome,
                  file: this.state.fileCaricato.file,
                  note: this.state.fileCaricato.note,
                  data: this.state.fileCaricato.data,
                  stato: this.state.fileCaricato.stato,
                  idFile: this.state.fileCaricato.id,
              }
            : this.state.fileDaEliminare
            ? {
                  nome:
                      this.state.fileDaEliminare.name ??
                      this.state.fileDaEliminare.nome,
                  file: this.state.fileDaEliminare.file,
                  note: this.state.fileDaEliminare.note,
                  data: this.state.fileDaEliminare.data,
                  stato: this.state.fileDaEliminare.stato,
                  idFile: this.state.fileDaEliminare.id,
              }
            : {};

        let infoClinichePulite = JSON.parse(
            JSON.stringify(
                Utils.removeEmptyValueFromObject(
                    this.props.segnalazione["infoCliniche"]
                )
            )
        );
        if (
            infoClinichePulite.listaDettaglioCli &&
            infoClinichePulite.listaDettaglioCli.length === 1 &&
            !infoClinichePulite.listaDettaglioCli[0].dettaglio &&
            !infoClinichePulite.listaDettaglioCli[0].sedeAnatomica
        ) {
            delete infoClinichePulite.listaDettaglioCli;
        }
        let jsonInfo = {
            infoCliniche: infoClinichePulite,
            infoEpidemiologiche: this.props.segnalazione["infoEpidemiologiche"],
            infoLaboratorio: this.props.segnalazione["infoLaboratorio"],
            files: file
        };
        if (this.state.malattiePremal["giornaliero"].includes(this.props.datiPaziente.malattia) || this.state.malattiePremal["settimanale"].includes(this.props.datiPaziente.malattia)) {
            jsonInfo["idoneitaPremal"] = Utils.retrieveIdoneitaPremal(
                this.props.segnalazione,
                this.props.datiPaziente,
                this.props.datiMedico
            );
        }
        this.props.showSpinner(true);
        let confermaInfoCliEpiLab = {
            jsonInfo: JSON.stringify(
                Utils.removeEmptyValueFromObject(jsonInfo)
            ),
        };
        for (let i = 0; i < this.state.malattie.length; i++) {
            if (
                this.state.malattie[i].codice ===
                this.props.datiPaziente.malattia
            ) {
                confermaInfoCliEpiLab["mailInserimento"] =
                    this.state.malattie[i].mailInserimento;
            }
        }

        SegnalazioniService.postConfermaInfoCliniche(
            this.props.segnalazione.idSegnalazione,
            confermaInfoCliEpiLab
        )
            .then((data) => {
                this.props.showSpinner(false);
                if (data && data.status === 200) {
                    let paramsModificaStato = {
                        idSegnalazione: this.props.segnalazione.idSegnalazione,
                        statoSegnalazione: statoSegnalazione,
                    };
                    SegnalazioniService.putStatoSegnalazione(
                        paramsModificaStato
                    )
                        .then((resModificaStato) => {
                            if (resModificaStato.status === 200) {
                                let segnalazioneSalvata =
                                    this.props.segnalazione;
                                segnalazioneSalvata["stepConfermati"] =
                                    data.data.stepConfermati;
                                segnalazioneSalvata = resModificaStato.data;
                                segnalazioneSalvata["stepConfermati"] =
                                    data.data.stepConfermati;
                                this.setState({
                                    mailInviataCorrettamente:
                                        data.data.mailInviataCorrettamente,
                                });
                                if (
                                    data.data.mailInviataCorrettamente ===
                                        true ||
                                    data.data.mailInviataCorrettamente === false
                                ) {
                                    this.props.segnalazioneCopia.statoSegnalazione =
                                        statoSegnalazione;
                                    $("#modalButton_confermaMail").trigger(
                                        "click"
                                    );
                                } else {
                                    this.nextStep(
                                        segnalazioneSalvata,
                                        segnalazioneSalvata
                                    );
                                }
                            }
                        })
                        .catch(() => {
                            this.props.showSpinner(false);
                            console.log("[ERROR] put Segnalazioni");
                        });
                }
            })
            .catch(() => {
                this.props.showSpinner(false);
                console.log("[ERROR] put Segnalazioni");
            });
    }

    setValoriCliniche() {
        if (this.props.segnalazioneCopia.infoCliniche) {
            let stateInfoCliniche = this.state.infoCliniche;
            stateInfoCliniche.informazioniCliniche = this.props
                .segnalazioneCopia.infoCliniche.informazioniCliniche
                ? this.props.segnalazioneCopia.infoCliniche.informazioniCliniche
                : this.state.infoCliniche.informazioniCliniche;
            if (this.props.segnalazioneCopia.infoCliniche.listaDettaglioCli) {
                for (
                    let i = 0;
                    i <
                    this.props.segnalazioneCopia.infoCliniche.listaDettaglioCli
                        .length;
                    i++
                ) {
                    stateInfoCliniche.listaDettaglioCli[i] = this.props
                        .segnalazioneCopia.infoCliniche.listaDettaglioCli[i]
                        ? this.props.segnalazioneCopia.infoCliniche
                              .listaDettaglioCli[i]
                        : this.state.infoCliniche.listaDettaglioCli[i];
                }
            }
            stateInfoCliniche.note = this.props.segnalazioneCopia.infoCliniche
                .note
                ? this.props.segnalazioneCopia.infoCliniche.note
                : this.state.infoCliniche.note;

            this.setState({ infoCliniche: stateInfoCliniche });
            for (
                let i = 0;
                i < stateInfoCliniche.listaDettaglioCli.length;
                i++
            ) {
                this.handleClickCliniche();
            }
        } else {
            this.handleClickCliniche();
        }
    }

    setValoriEpidemiologici() {
        if (this.props.segnalazioneCopia.infoEpidemiologiche) {
            let stateInfoEpidemiologiche = this.state.infoEpidemiologiche;
            stateInfoEpidemiologiche.infoEpidemiologiche = this.props
                .segnalazioneCopia.infoEpidemiologiche.infoEpidemiologiche
                ? this.props.segnalazioneCopia.infoEpidemiologiche
                      .infoEpidemiologiche
                : this.state.infoEpidemiologiche.infoEpidemiologiche;
            if (
                this.props.segnalazioneCopia.infoEpidemiologiche
                    .listaDettaglioEpi
            ) {
                for (
                    let i = 0;
                    i <
                    this.props.segnalazioneCopia.infoEpidemiologiche
                        .listaDettaglioEpi.length;
                    i++
                ) {
                    stateInfoEpidemiologiche.listaDettaglioEpi[i] = this.props
                        .segnalazioneCopia.infoEpidemiologiche
                        .listaDettaglioEpi[i]
                        ? this.props.segnalazioneCopia.infoEpidemiologiche
                              .listaDettaglioEpi[i]
                        : this.state.infoCliniche.listaDettaglioCli[i];
                }
            }
            this.setState({ infoEpidemiologiche: stateInfoEpidemiologiche });
            for (
                let i = 0;
                i < stateInfoEpidemiologiche.listaDettaglioEpi.length;
                i++
            ) {
                this.handleClickEpidemiologico();
            }
        } else {
            this.handleClickEpidemiologico();
        }
    }

    setValoriLaboratorio() {
        if (this.props.segnalazioneCopia.infoLaboratorio) {
            let stateInfoLab = this.state.infoLaboratorio;
            stateInfoLab.infoLaboratorio = this.props.segnalazioneCopia
                .infoLaboratorio.infoLaboratorio
                ? this.props.segnalazioneCopia.infoLaboratorio.infoLaboratorio
                : this.state.infoLaboratorio.infoLaboratorio;
            stateInfoLab.tipoLaboratorio = this.props.segnalazioneCopia
                .infoLaboratorio.tipoLaboratorio
                ? this.props.segnalazioneCopia.infoLaboratorio.tipoLaboratorio
                : "";
            stateInfoLab.dataPrelievo = this.props.segnalazioneCopia
                .infoLaboratorio.dataPrelievo
                ? Utils.formatDateISO(
                      this.props.segnalazioneCopia.infoLaboratorio.dataPrelievo
                  )
                : "";
            stateInfoLab.dataEsame = this.props.segnalazioneCopia
                .infoLaboratorio.dataEsame
                ? Utils.formatDateISO(
                      this.props.segnalazioneCopia.infoLaboratorio.dataEsame
                  )
                : "";

            if (
                this.props.segnalazioneCopia.infoLaboratorio.listaDettaglioLab
            ) {
                for (
                    let i = 0;
                    i <
                    this.props.segnalazioneCopia.infoLaboratorio
                        .listaDettaglioLab.length;
                    i++
                ) {
                    stateInfoLab.listaDettaglioLab[i] = this.props
                        .segnalazioneCopia.infoLaboratorio.listaDettaglioLab[i]
                        ? this.props.segnalazioneCopia.infoLaboratorio
                              .listaDettaglioLab[i]
                        : this.state.infoLaboratorio.listaDettaglioLab[i];
                }
            }
            this.setState({ infoLaboratorio: stateInfoLab });
            for (let i = 0; i < stateInfoLab.listaDettaglioLab.length; i++) {
                this.handleClickLaboratorio();
            }
        } else {
            this.handleClickLaboratorio();
        }
    }

    aggiungiElementoClinica() {
        let infoClinicaCopia = this.state.infoCliniche;
        infoClinicaCopia.listaDettaglioCli.push({
            dettaglio: "",
            sedeAnatomica: "",
        });
        this.setState({ infoCliniche: infoClinicaCopia });
    }

    aggiungElementoEpidemiologico() {
        let infoEpiCopia = this.state.infoEpidemiologiche;
        infoEpiCopia.listaDettaglioEpi.push("");
        this.setState({ infoEpidemiologiche: infoEpiCopia });
    }

    aggiungiElementoLaboratorio() {
        let infoLabCopia = this.state.infoLaboratorio;
        infoLabCopia.listaDettaglioLab.push("");
        this.setState({ infoLaboratorio: infoLabCopia });
    }

    handleChangeInfoCliniche(event) {
        let infoCliniche = this.state.infoCliniche;
        infoCliniche.informazioniCliniche = event.target.value;
        infoCliniche.listaDettaglioCli = [
            {
                dettaglio: "",
                sedeAnatomica: "",
                numeroLesioni: "",
            },
        ];

        let infoClinichePulito = this.pulisciValori(infoCliniche);
        this.setState({
            boxesClinica: [],
            infoCliniche: infoClinichePulito,
            clicksClinica: 0,
        });
    }

    handleChangeInfoEpidemiologiche(event) {
        let infoEpidemiologiche = this.state.infoEpidemiologiche;
        infoEpidemiologiche.infoEpidemiologiche = event.target.value;
        infoEpidemiologiche.listaDettaglioEpi = [""];
        this.setState({
            boxEpi: [],
            infoEpidemiologiche: infoEpidemiologiche,
            clicksEpidemiologico: 0,
        });
    }

    handleChangeInfoLaboratorio(event) {
        let infoLaboratorio = this.state.infoLaboratorio;
        infoLaboratorio.infoLaboratorio = event.target.value;
        infoLaboratorio.listaDettaglioLab = [""];
        infoLaboratorio.dataPrelievo = "";
        infoLaboratorio.dataEsame = "";
        infoLaboratorio.tipoLaboratorio = "";
        this.setState({
            boxLab: [],
            infoLaboratorio: infoLaboratorio,
            clicksLaboratorio: 0,
        });
    }

    handleChangeTipoLab(event) {
        let infoLab = this.state.infoLaboratorio;
        infoLab.tipoLaboratorio = event.target.value;
        this.setState({ infoLaboratorio: infoLab });
    }

    _validate(clickSalvaOConferma) {
        if (
            this.state.infoLaboratorio.dataPrelievo !== "" &&
            Utils.isDateInValid(
                Utils.transformDateForBackend(
                    this.state.infoLaboratorio.dataPrelievo
                ),
                "-"
            )
        ) {
            let { t } = this.props;
            let newMessaggio = Utils.replaceContentString(
                t("Messages.ERR_01_01_0C_0A"),
                "<nome campo>",
                t("InfoLaboratorio.dataPrelievo")
            );
            return this.aggiungiToaster(newMessaggio);
        }
        if (
            this.state.infoLaboratorio.dataEsame !== "" &&
            Utils.isDateInValid(
                Utils.transformDateForBackend(
                    this.state.infoLaboratorio.dataEsame
                ),
                "-"
            )
        ) {
            let { t } = this.props;
            let newMessaggio = Utils.replaceContentString(
                t("Messages.ERR_01_01_0C_0A"),
                "<nome campo>",
                t("InfoLaboratorio.dataEsame")
            );
            return this.aggiungiToaster(newMessaggio);
        }
        
        const dettagli = this.state.infoCliniche.listaDettaglioCli.map((item) => item.dettaglio);
        const setC = new Set(dettagli);
        if (setC.size < dettagli.length)
        {
            return this.aggiungiToaster(["Messages.ERR_INFO_CLI"])
        }

        const listaDettaglioEpid = this.state.infoEpidemiologiche.listaDettaglioEpi;
        const setE = new Set(listaDettaglioEpid);
        if (setE.size < listaDettaglioEpid.length)
        {
            return this.aggiungiToaster(["Messages.ERR_INFO_EPI"])
        }

        const listaDettaglioLabor = this.state.infoLaboratorio.listaDettaglioLab;
        const setL = new Set(listaDettaglioLabor);
        if (setL.size < listaDettaglioLabor.length)
        {
            return this.aggiungiToaster(["Messages.ERR_INFO_LAB"])
        }

        let validateDataPrelievo = false;
        let checkDataPrelievo = false;
        if (this.state.infoLaboratorio.dataPrelievo !== "") {
            validateDataPrelievo = Utils.checkDateInterval(
                this.state.infoLaboratorio.dataPrelievo,
                "31/12/1899"
            );
            checkDataPrelievo = Utils.checkDateLowerToday(
                this.state.infoLaboratorio.dataPrelievo
            );
        }
        if (validateDataPrelievo) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0D_0B"]);
        } else if (checkDataPrelievo) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0D_0C"]);
        }

        if (this.state.infoLaboratorio.dataEsame !== "") {
            let validateDataEsame = Utils.checkDateInterval(
                this.state.infoLaboratorio.dataEsame,
                "31/12/1899"
            );
            let checkDataEsame = Utils.checkDateLowerToday(
                this.state.infoLaboratorio.dataEsame
            );
            if (validateDataEsame) {
                return this.aggiungiToaster(["Messages.ERR_01_01_0F_AA"]);
            } else if (checkDataEsame) {
                return this.aggiungiToaster(["Messages.ERR_01_01_0F_AB"]);
            }
        }

        // sicuramente bisogna inserire controlla data di dataEsame

        let ObjectForBackEndInfoCliniche = {};
        ObjectForBackEndInfoCliniche["informazioniCliniche"] =
            this.state.infoCliniche.informazioniCliniche;
        let listaDettaglioCli = Utils.unique(
            this.state.infoCliniche.listaDettaglioCli
        );
        ObjectForBackEndInfoCliniche["listaDettaglioCli"] =
            Utils.removeEmptyValueFromObject(listaDettaglioCli);
        ObjectForBackEndInfoCliniche["note"] = this.state.infoCliniche.note;

        let resCliniche = Utils.removeEmptyValueFromObject(
            ObjectForBackEndInfoCliniche
        );
        this.props.segnalazione["infoCliniche"] = resCliniche;

        let ObjectForBackEndInfoEpidemiologiche = {};
        ObjectForBackEndInfoEpidemiologiche["infoEpidemiologiche"] =
            this.state.infoEpidemiologiche.infoEpidemiologiche;
        ObjectForBackEndInfoEpidemiologiche["listaDettaglioEpi"] = Utils.unique(
            this.state.infoEpidemiologiche.listaDettaglioEpi
        );
        let resEpidemiologiche = Utils.removeEmptyValueFromObject(
            ObjectForBackEndInfoEpidemiologiche
        );
        this.props.segnalazione["infoEpidemiologiche"] = resEpidemiologiche;

        let ObjectForBackEndInfoLaboratorio = {};
        ObjectForBackEndInfoLaboratorio["infoLaboratorio"] =
            this.state.infoLaboratorio.infoLaboratorio;
        ObjectForBackEndInfoLaboratorio["listaDettaglioLab"] = Utils.unique(
            this.state.infoLaboratorio.listaDettaglioLab
        );
        ObjectForBackEndInfoLaboratorio["tipoLaboratorio"] =
            this.state.infoLaboratorio.tipoLaboratorio;
        ObjectForBackEndInfoLaboratorio["dataPrelievo"] =
            Utils.transformDateForBackend(
                this.state.infoLaboratorio.dataPrelievo
            );
        ObjectForBackEndInfoLaboratorio["dataEsame"] =
            Utils.transformDateForBackend(this.state.infoLaboratorio.dataEsame);
        let resLaboratorio = Utils.removeEmptyValueFromObject(
            ObjectForBackEndInfoLaboratorio
        );
        this.props.segnalazione["infoLaboratorio"] = resLaboratorio;
        let arrayInfoCliniche = [];
        if (ObjectForBackEndInfoCliniche.listaDettaglioCli) {
            ObjectForBackEndInfoCliniche.listaDettaglioCli.forEach((el) => {
                arrayInfoCliniche.push(el);
            });
        }
        let arrayDettaglioCliniche = [];
        if (arrayInfoCliniche && arrayInfoCliniche.length > 0) {
            arrayInfoCliniche.forEach((el) => {
                if (el.dettaglio) {
                    arrayDettaglioCliniche.push(el.dettaglio);
                }
            });
        }

        let paramsClassificazioneCaso = {
            codiceMalattia: this.props.segnalazioneCopia.malattia,
            infoCliniche: arrayDettaglioCliniche,
            infoEpidemiologiche:
                ObjectForBackEndInfoEpidemiologiche.listaDettaglioEpi,
            infoLaboratorio: ObjectForBackEndInfoLaboratorio.listaDettaglioLab,
        };
        SegnalazioniService.getClassificazioneCaso(paramsClassificazioneCaso)
            .then((res) => {
                if (res.status === 200) {
                    if (clickSalvaOConferma === 1) {
                        this.callToPutSegnalazione(res.data.codice).then();
                    } else {
                        this.callToConfermaInfo(res.data.codice).then();
                    }
                }
            })
            .catch((reason) => {
                console.log("[ERROR] put segnalazione " + reason);
            });
    }

    controlloDatiToaster(tipo) {
        let textList = [];
        let infoCliniche = this.state.infoCliniche;
        let infoEpidemiologiche = this.state.infoEpidemiologiche;
        let infoLaboratorio = this.state.infoLaboratorio;

        if (!infoCliniche.informazioniCliniche)
            textList.push('Campo "Informazioni Cliniche" mancante');
        if (!infoEpidemiologiche.infoEpidemiologiche)
            textList.push('Campo "Informazioni Epidemiologiche" mancante');
        if (!infoLaboratorio.infoLaboratorio)
            textList.push('Campo "Informazioni di Laboratorio" mancante');
        if (
            infoCliniche.informazioniCliniche === "1" &&
            !infoCliniche.listaDettaglioCli[0].dettaglio
        )
            textList.push('Campo "Dettaglio Informazioni Cliniche" mancante');
        if (
            infoEpidemiologiche.infoEpidemiologiche === "1" &&
            !infoEpidemiologiche.listaDettaglioEpi[0]
        )
            textList.push(
                'Campo "Dettaglio Informazioni Epidemiologiche" mancante'
            );
        if (
            this.state.listaInfoLaboratorio.length > 0 &&
            infoLaboratorio.infoLaboratorio === "1" &&
            !infoLaboratorio.listaDettaglioLab[0]
        )
            textList.push(
                'Campo "Dettaglio Informazioni Laboratorio" mancante'
            );
        if (
            infoLaboratorio.dataEsame !== "" &&
            Utils.isDateInValid(
                Utils.transformDateForBackend(infoLaboratorio.dataEsame),
                "-"
            )
        )
            textList.push('Campo "Data di esame" errato');

        if (textList.length > 0 && tipo === "1")
            return this.aggiungiToaster(textList, true);
        else if (
            textList.length > 0 &&
            tipo === "2" &&
            this.props.segnalazioneCopia.infoLaboratorio &&
            this.props.segnalazioneCopia.stepConfermati &&
            this.props.segnalazioneCopia.stepConfermati.infoConfermate
        )
            return this.aggiungiToaster(textList, true);
        else {
            if (tipo === "1") {
                if (
                    (this.props.segnalazione &&
                        this.props.segnalazione.migrazione) ||
                    SessioneUtente.getInstance().ruoliUtente ===
                        Ruoli.Operatore_Laboratorio.descrizione ||
                    (this.props.segnalazioneCopia &&
                        (this.props.segnalazioneCopia.statoSegnalazione ===
                            OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                .codice ||
                            this.props.segnalazioneCopia.statoValidazione ===
                                OggettiUtili.statoValidazioneByLabel.Validata
                                    .codice))
                ) {
                    this.nextStep(
                        this.props.segnalazioneCopia,
                        this.props.segnalazioneCopia
                    );
                } else {
                    this._validate(0);
                }
            } else if (tipo === "2") {
                this._validate(1);
            }
        }
    }

    riceviValore(field, i) {
        let infoLaboratorioNew = this.state.infoLaboratorio;
        let infoClinicheNew = this.state.infoCliniche;
        let click = this.state.clicksClinica - 1;
        if (field.currentTarget) {
            if (field.currentTarget.id === "dataPrelievo") {
                infoLaboratorioNew.dataPrelievo = field.currentTarget.value;
                this.setState({ infoLaboratorio: infoLaboratorioNew });
            } else if (field.currentTarget.id === "dataEsame") {
                infoLaboratorioNew.dataEsame = field.currentTarget.value;
                this.setState({ infoLaboratorio: infoLaboratorioNew });
            } else if (field.currentTarget.id === "numeroLesioni" + i) {
                infoClinicheNew.listaDettaglioCli[i].numeroLesioni =
                    field.currentTarget.value;
                this.setState({
                    infoCliniche: infoClinicheNew,
                    clicksClinica: click,
                });
            }
        }
    }

    riceviValoreCliniche(event) {
        let cliniche = this.state.infoCliniche;
        let click = this.state.clicksClinica - 1;
        let indice = parseInt(
            event.target.id.replace("listaInfoClinicheDettaglio", "")
        );
        cliniche.listaDettaglioCli[indice].dettaglio = event.target.value;
        if (event.target.value !== "85") {
            cliniche.listaDettaglioCli[indice].numeroLesioni = "";
            cliniche.listaDettaglioCli[indice].sedeAnatomica = "";
            $(document).ready(function () {
                document
                    .querySelectorAll("#sedeAnatomica" + indice + " option")
                    .forEach(function (op) {
                        op.selected = false;
                    });
            });
        }
        this.setState({ infoCliniche: cliniche, clicksClinica: click });

        $(document).ready(function () {
            $(".selectpicker").selectpicker("refresh");
        });
    }

    riceviValoreNote(field, event) {
        let infoCliniche = this.state.infoCliniche;
        infoCliniche[field] = event.target.value;
        this.setState({ infoCliniche: infoCliniche });
    }

    pulisciValori(state) {
        let newState = state;
        if (newState.informazioniCliniche !== "01") {
            newState.note = "";
        }
        return newState;
    }

    riceviValoreEpidemiologiche(event) {
        let infoEpi = this.state.infoEpidemiologiche;
        let click = this.state.clicksEpidemiologico - 1;
        let indice = parseInt(
            event.target.id.replace("listaInfoEpidemiologiche", "")
        );
        infoEpi.listaDettaglioEpi[indice] = event.target.value;
        this.setState({
            infoEpidemiologiche: infoEpi,
            clicksEpidemiologico: click,
        });
    }

    riceviValoreLaboratorio(event) {
        let infoLab = this.state.infoLaboratorio;
        let click = this.state.clicksLaboratorio - 1;
        let indice = parseInt(
            event.target.id.replace("listaInfoLaboratorio", "")
        );
        infoLab.listaDettaglioLab[indice] = event.target.value;
        this.setState({ infoLaboratorio: infoLab, clicksLaboratorio: click });
    }

    eliminaRowInfoCliniche(i) {
        let infoCliniche = this.state.infoCliniche;
        let boxes = this.state.boxesClinica;
        let clicks = this.state.clicksClinica;
        infoCliniche.listaDettaglioCli.splice(i, 1);
        boxes.splice(i, 1);
        this.setState({ boxesClinica: boxes, infoCliniche: infoCliniche });
        if (i === 1) clicks = clicks - 1;
        else clicks = clicks - 2;
        this.handleClickCliniche(clicks);
    }

    riceviValoreMultiselect(event, i) {
        let infoCliniche = this.state.infoCliniche;
        let selectedMalattie = [];

        for (let i = 0; i < event.currentTarget.selectedOptions.length; i++) {
            selectedMalattie[i] = event.currentTarget.selectedOptions[i].value;
        }
        infoCliniche.listaDettaglioCli[i].sedeAnatomica = selectedMalattie;
        this.setState({ infoCliniche: infoCliniche });
    }

    handleClickCliniche(clickElimina) {
        let clicks = clickElimina
            ? clickElimina
            : this.state.clicksClinica ===
              this.state.infoCliniche.listaDettaglioCli.length
            ? this.state.clicksClinica
            : this.state.clicksClinica + 1;
        let listaValore = this.state.infoCliniche.listaDettaglioCli;
        let boxClinica = [];
        let sediAnatomiche = Utils.mapToArray(OggettiUtili.SedeAnatomica).sort(
            Utils.SorterObjectDesc
        );
        sediAnatomiche.push({
            codice: "99",
            descrizione: "Altro",
        });
        for (let i = 0; i < clicks; i++) {
            boxClinica.push(
                <>
                    <div className="row" style={{ paddingTop: "10px" }}>
                        <div className="col-lg-4">
                            <p className={styles.testo}>
                                {this.props.t(
                                    "InfoCliniche.dettaglioInfoCliniche"
                                )}{" "}
                                {i < 1 &&
                                this.state.infoCliniche &&
                                this.state.infoCliniche.informazioniCliniche ===
                                    "1" ? (
                                    <span className={styles.mandatoryColor}>
                                        *
                                    </span>
                                ) : (
                                    ""
                                )}
                            </p>
                        </div>
                        <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4 dettaglioInfo' : ''}`}>
                            <Select
                                value={listaValore[i].dettaglio}
                                disabled={
                                    this.state.infoCliniche &&
                                    this.state.infoCliniche
                                        .informazioniCliniche !== "1"
                                }
                                onChange={this.riceviValoreCliniche}
                                id={"listaInfoClinicheDettaglio" + i}
                                functionMap={this.state.listaInfoCliniche.map(
                                    (oggetto) => {
                                        return (
                                            <option
                                                value={
                                                    oggetto.codiceInfoClinica
                                                }
                                            >
                                                {oggetto.descrizioneInfoClinica}
                                            </option>
                                        );
                                    }
                                )}
                            ></Select>
                        </div>
                        {i < 1 ? (
                            <div
                                className="col-lg-3"
                                style={{
                                    opacity:
                                        (this.state.infoCliniche &&
                                            this.state.infoCliniche
                                                .informazioniCliniche !==
                                                "1") ||
                                        (this.props.segnalazione &&
                                            this.props.segnalazione
                                                .migrazione) ||
                                        (this.props.segnalazioneCopia &&
                                            this.props.segnalazioneCopia
                                                .statoSegnalazione &&
                                            this.props.segnalazioneCopia
                                                .statoSegnalazione ===
                                                OggettiUtili
                                                    .statoSegnalazioneByLabel
                                                    .Archiviato.codice) ||
                                        this.props.segnalazioneCopia
                                            .statoValidazione ===
                                            OggettiUtili.statoValidazioneByLabel
                                                .Validata.codice
                                            ? "0.5"
                                            : "1",
                                }}
                            >
                                <Button
                                    onClick={() => {
                                        this.aggiungiElementoClinica();
                                        this.handleClickCliniche();
                                    }}
                                    className={styles.testo}
                                    classes="btn mt-2 btnBluOutline mb-1 "
                                    style={{
                                        padding: "5px",
                                        border: "none",
                                        background: "none",
                                        float: "right",
                                    }}
                                    text="Aggiungi dettaglio "
                                    icon={
                                        <Icon
                                            style={{
                                                paddingLeft: "4px",
                                                fill: "#0073e6",
                                            }}
                                            id="it-plus-circle"
                                        />
                                    }
                                    disabled={
                                        (this.state.infoCliniche &&
                                            this.state.infoCliniche
                                                .informazioniCliniche !==
                                                "1") ||
                                        (this.props.segnalazione &&
                                            this.props.segnalazione
                                                .migrazione) ||
                                        this.props.segnalazioneCopia
                                            .statoSegnalazione ===
                                            OggettiUtili
                                                .statoSegnalazioneByLabel
                                                .Archiviato.codice ||
                                        this.props.segnalazioneCopia
                                            .statoValidazione ===
                                            OggettiUtili.statoValidazioneByLabel
                                                .Validata.codice
                                    }
                                />
                            </div>
                        ) : !(
                              (this.props.segnalazione &&
                                  this.props.segnalazione.migrazione) ||
                              (this.props.segnalazioneCopia &&
                                  this.props.segnalazioneCopia
                                      .statoSegnalazione &&
                                  this.props.segnalazioneCopia
                                      .statoSegnalazione ===
                                      OggettiUtili.statoSegnalazioneByLabel
                                          .Archiviato.codice) ||
                              this.props.segnalazioneCopia.statoValidazione ===
                                  OggettiUtili.statoValidazioneByLabel.Validata
                                      .codice
                          ) ? (
                            <span
                                id={i}
                                onClick={() => this.eliminaRowInfoCliniche(i)}
                            >
                                <Icon
                                    id={"it-delete"}
                                    style={{
                                        fill: "red",
                                        marginTop: "5px",
                                        cursor: "pointer",
                                    }}
                                />
                            </span>
                        ) : (
                            <div></div>
                        )}
                    </div>
                    {this.props.segnalazioneCopia.malattia === "0578" && (
                        <div>
                            <div className="row" style={{ paddingTop: "10px" }}>
                                <div className="col-lg-4">
                                    <p className={styles.testo}>
                                        {this.props.t(
                                            "InfoCliniche.numeroLesioni"
                                        )}
                                    </p>
                                </div>
                                <div className="col-lg-5">
                                    <Select
                                        value={
                                            this.state.infoCliniche
                                                .listaDettaglioCli[i]
                                                .numeroLesioni
                                        }
                                        disabled={
                                            (this.state.infoCliniche &&
                                                this.state.infoCliniche
                                                    .informazioniCliniche !==
                                                    "1") ||
                                            this.state.infoCliniche
                                                .listaDettaglioCli[i]
                                                .dettaglio !== "85"
                                        }
                                        onChange={(e) =>
                                            this.riceviValore(e, i)
                                        }
                                        id={"numeroLesioni" + i}
                                        field={"numeroLesioni"}
                                        functionMap={OggettiUtili.NumeroLesioni.map(
                                            (oggetto) => {
                                                return (
                                                    <option
                                                        value={oggetto.codice}
                                                    >
                                                        {oggetto.descrizione}
                                                    </option>
                                                );
                                            }
                                        )}
                                    ></Select>
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: "10px" }}>
                                <div className="col-lg-4">
                                    <p className={styles.testo}>
                                        {this.props.t(
                                            "InfoCliniche.sedeAnatomica"
                                        )}
                                    </p>
                                </div>
                                <div className="col-lg-5">
                                    <SelectAutocomplete
                                        id={"sedeAnatomica" + i}
                                        field={"sedeAnatomica" + i}
                                        disabled={
                                            (this.state.infoCliniche &&
                                                this.state.infoCliniche
                                                    .informazioniCliniche !==
                                                    "1") ||
                                            this.state.infoCliniche
                                                .listaDettaglioCli[i]
                                                .dettaglio !== "85"
                                        }
                                        onChange={(e) =>
                                            this.riceviValoreMultiselect(e, i)
                                        }
                                        multiple={"true"}
                                        ricerca={true}
                                        defaultValue={
                                            this.state.infoCliniche
                                                .listaDettaglioCli[i]
                                                .sedeAnatomica
                                        }
                                        functionMap={sediAnatomiche.map(
                                            (oggetto) => {
                                                return (
                                                    <option
                                                        value={oggetto.codice}
                                                    >
                                                        {oggetto.descrizione}
                                                    </option>
                                                );
                                            }
                                        )}
                                    ></SelectAutocomplete>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            );
        }
        this.setState({ clicksClinica: clicks, boxesClinica: boxClinica });
    }

    eliminaRowInfoEpi(i) {
        let infoEpi = this.state.infoEpidemiologiche;
        let boxes = this.state.boxesEpidem;
        let clicks = this.state.clicksEpidemiologico;
        infoEpi.listaDettaglioEpi.splice(i, 1);
        boxes.splice(i, 1);
        this.setState({ boxesEpidem: boxes, infoEpidemiologiche: infoEpi });
        if (i === 1) clicks = clicks - 1;
        else clicks = clicks - 2;
        this.handleClickEpidemiologico(clicks);
    }

    handleClickEpidemiologico(clickElimina) {
        let clicks = clickElimina
            ? clickElimina
            : this.state.clicksEpidemiologico ===
              this.state.infoEpidemiologiche.listaDettaglioEpi.length
            ? this.state.clicksEpidemiologico
            : this.state.clicksEpidemiologico + 1;
        let listaValore = this.state.infoEpidemiologiche.listaDettaglioEpi;
        let boxEpi = [];
        for (let i = 0; i < clicks; i++)
            boxEpi.push(
                <div className="row" style={{ paddingTop: "10px" }}>
                    <div className="col-lg-4">
                        <p className={styles.testo}>
                            {this.props.t(
                                "InfoEpidemiologiche.infoDettaglioEpidemiologiche"
                            )}
                            {i < 1 &&
                            this.state.infoEpidemiologiche &&
                            this.state.infoEpidemiologiche
                                .infoEpidemiologiche === "1" ? (
                                <span className={styles.mandatoryColor}>*</span>
                            ) : (
                                ""
                            )}
                        </p>
                    </div>

                    <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4 dettaglioInfo' : ''}`}>
                        <Select
                            value={listaValore[i]}
                            disabled={
                                this.state.infoEpidemiologiche &&
                                this.state.infoEpidemiologiche
                                    .infoEpidemiologiche !== "1"
                            }
                            onChange={this.riceviValoreEpidemiologiche}
                            id={"listaInfoEpidemiologiche" + i}
                            functionMap={this.state.listaInfoEpidemiologiche.map(
                                (oggetto) => {
                                    return (
                                        <option
                                            value={
                                                oggetto.codiceInfoEpidemiologica
                                            }
                                        >
                                            {
                                                oggetto.descrizioneInfoEpidemiologica
                                            }
                                        </option>
                                    );
                                }
                            )}
                        ></Select>
                    </div>
                    {i < 1 ? (
                        <div className="col-lg-3">
                            <Button
                                onClick={() => {
                                    this.aggiungElementoEpidemiologico();
                                    this.handleClickEpidemiologico();
                                }}
                                className={styles.testo}
                                classes="btn mt-2 btnBluOutline mb-1 "
                                style={{
                                    padding: "5px",
                                    border: "none",
                                    background: "none",
                                    float: "right",
                                    opacity:
                                        (this.state.infoEpidemiologiche &&
                                            this.state.infoEpidemiologiche
                                                .infoEpidemiologiche !== "1") ||
                                        (this.props.segnalazione &&
                                            this.props.segnalazione
                                                .migrazione) ||
                                        this.props.segnalazioneCopia
                                            .statoSegnalazione ===
                                            OggettiUtili
                                                .statoSegnalazioneByLabel
                                                .Archiviato.codice ||
                                        this.props.segnalazioneCopia
                                            .statoValidazione ===
                                            OggettiUtili.statoValidazioneByLabel
                                                .Validata.codice
                                            ? "0.5"
                                            : "1",
                                }}
                                text="Aggiungi dettaglio "
                                icon={
                                    <Icon
                                        style={{
                                            paddingLeft: "4px",
                                            fill: "#0073e6",
                                        }}
                                        id="it-plus-circle"
                                    />
                                }
                                disabled={
                                    (this.state.infoEpidemiologiche &&
                                        this.state.infoEpidemiologiche
                                            .infoEpidemiologiche !== "1") ||
                                    (this.props.segnalazione &&
                                        this.props.segnalazione.migrazione) ||
                                    this.props.segnalazioneCopia
                                        .statoSegnalazione ===
                                        OggettiUtili.statoSegnalazioneByLabel
                                            .Archiviato.codice ||
                                    this.props.segnalazioneCopia
                                        .statoValidazione ===
                                        OggettiUtili.statoValidazioneByLabel
                                            .Validata.codice
                                }
                            />
                        </div>
                    ) : !(
                          (this.props.segnalazione &&
                              this.props.segnalazione.migrazione) ||
                          (this.props.segnalazioneCopia &&
                              this.props.segnalazioneCopia.statoSegnalazione &&
                              this.props.segnalazioneCopia.statoSegnalazione ===
                                  OggettiUtili.statoSegnalazioneByLabel
                                      .Archiviato.codice) ||
                          this.props.segnalazioneCopia.statoValidazione ===
                              OggettiUtili.statoValidazioneByLabel.Validata
                                  .codice
                      ) ? (
                        <span id={i} onClick={() => this.eliminaRowInfoEpi(i)}>
                            <Icon
                                id={"it-delete"}
                                style={{
                                    fill: "red",
                                    marginTop: "5px",
                                    cursor: "pointer",
                                }}
                            />
                        </span>
                    ) : (
                        <div></div>
                    )}
                </div>
            );
        this.setState({ boxesEpidem: boxEpi, clicksEpidemiologico: clicks });
    }

    eliminaRowInfoLab(i) {
        let infoLab = this.state.infoLaboratorio;
        let boxes = this.state.boxesLab;
        let clicks = this.state.clicksLaboratorio;
        infoLab.listaDettaglioLab.splice(i, 1);
        boxes.splice(i, 1);
        this.setState({ boxesLab: boxes, infoLaboratorio: infoLab });
        if (i === 1) clicks = clicks - 1;
        else clicks = clicks - 2;
        this.handleClickLaboratorio(clicks);
    }

    handleClickLaboratorio(clickElimina) {
        let clicks = clickElimina
            ? clickElimina
            : this.state.clicksLaboratorio ===
              this.state.infoLaboratorio.listaDettaglioLab.length
            ? this.state.clicksLaboratorio
            : this.state.clicksLaboratorio + 1;
        let listaValore = this.state.infoLaboratorio.listaDettaglioLab;
        let boxLab = [];
        for (let i = 0; i < clicks; i++)
            boxLab.push(
                <div className="row" style={{ paddingTop: "10px" }}>
                    <div className="col-lg-4">
                        <p className={styles.testo}>
                            {this.props.t(
                                "InfoLaboratorio.infoDettaglioLaboratorio"
                            )}
                            {i < 1 &&
                            this.state.infoLaboratorio &&
                            this.state.infoLaboratorio.infoLaboratorio ===
                                "1" ? (
                                <span className={styles.mandatoryColor}>*</span>
                            ) : (
                                ""
                            )}{" "}
                        </p>
                    </div>
                    <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4 dettaglioInfo' : ''}`}>
                        <Select
                            disabled={
                                this.state.infoLaboratorio &&
                                this.state.infoLaboratorio.infoLaboratorio !==
                                    "1"
                            }
                            addclass={this.props.segnalazione?.integrataLIS === true || this.props.segnalazione.utenteInserimento==='LIS' || this.state.autore==='LIS'? styles.cellAzure : ''}
                            value={listaValore[i]}
                            id={"listaInfoLaboratorio" + i}
                            onChange={this.riceviValoreLaboratorio}
                            functionMap={this.state.listaInfoLaboratorio.map(
                                (oggetto) => {
                                    return (
                                        <option
                                            value={
                                                oggetto.codiceInfoLaboratorio
                                            }
                                        >
                                            {oggetto.descrizioneInfoLaboratorio}
                                        </option>
                                    );
                                }
                            )}
                        ></Select>
                    </div>
                    {i < 1 ? (
                        <div className="col-lg-3">
                            <Button
                                onClick={() => {
                                    this.aggiungiElementoLaboratorio();
                                    this.handleClickLaboratorio();
                                }}
                                className={styles.testo}
                                classes="btn mt-2 btnBluOutline mb-1 "
                                style={{
                                    padding: "5px",
                                    border: "none",
                                    background: "none",
                                    float: "right",
                                    opacity:
                                        (this.state.infoLaboratorio &&
                                            this.state.infoLaboratorio
                                                .infoLaboratorio !== "1") ||
                                        (this.props.segnalazione &&
                                            this.props.segnalazione
                                                .migrazione) ||
                                        this.props.segnalazioneCopia
                                            .statoSegnalazione ===
                                            OggettiUtili
                                                .statoSegnalazioneByLabel
                                                .Archiviato.codice ||
                                        this.props.segnalazioneCopia
                                            .statoValidazione ===
                                            OggettiUtili.statoValidazioneByLabel
                                                .Validata.codice
                                            ? "0.5"
                                            : "1",
                                }}
                                text="Aggiungi dettaglio "
                                icon={
                                    <Icon
                                        style={{
                                            paddingLeft: "4px",
                                            fill: "#0073e6",
                                        }}
                                        id="it-plus-circle"
                                    />
                                }
                                disabled={
                                    (this.state.infoLaboratorio &&
                                        this.state.infoLaboratorio
                                            .infoLaboratorio !== "1") ||
                                    (this.props.segnalazione &&
                                        this.props.segnalazione.migrazione) ||
                                    this.props.segnalazioneCopia
                                        .statoSegnalazione ===
                                        OggettiUtili.statoSegnalazioneByLabel
                                            .Archiviato.codice ||
                                    this.props.segnalazioneCopia
                                        .statoValidazione ===
                                        OggettiUtili.statoValidazioneByLabel
                                            .Validata.codice
                                }
                            />
                        </div>
                    ) : !(
                          (this.props.segnalazione &&
                              this.props.segnalazione.migrazione) ||
                          (this.props.segnalazioneCopia &&
                              this.props.segnalazioneCopia.statoSegnalazione &&
                              this.props.segnalazioneCopia.statoSegnalazione ===
                                  OggettiUtili.statoSegnalazioneByLabel
                                      .Archiviato.codice) ||
                          this.props.segnalazioneCopia.statoValidazione ===
                              OggettiUtili.statoValidazioneByLabel.Validata
                                  .codice
                      ) ? (
                        <span id={i} onClick={() => this.eliminaRowInfoLab(i)}>
                            <Icon
                                id={"it-delete"}
                                style={{
                                    fill: "red",
                                    marginTop: "5px",
                                    cursor: "pointer",
                                }}
                            />
                        </span>
                    ) : (
                        <div></div>
                    )}
                </div>
            );

        this.setState({ boxesLab: boxLab, clicksLaboratorio: clicks });
    }

    setStatePadre(files) {
        if (files.fileCaricato && files.fileDaCaricare) {
            this.setState({
                fileCaricato: files.fileCaricato,
                fileDaCaricare: files.fileDaCaricare,
            });
        } else if (files.fileCaricato) {
            this.setState({ fileCaricato: files.fileCaricato });
        } else if (files.fileDaEliminare) {
            this.setState({
                fileCaricato: null,
                fileDaCaricare: null,
                fileDaEliminare: files.fileDaEliminare,
            });
        } else {
            this.setState({ fileDaCaricare: files.fileDaCaricare });
        }
    }

    caricaPdf(event) {
        this.props.showSpinner(true);
        let dimensioneMassimaFile = parseInt(globals["dimesione-massima-file"]);
        let file = event.target.files[0];
        if (file !== undefined && file.type !== undefined) {
            if (file.type !== "application/pdf") {
                this.props.showSpinner(false);
                this.aggiungiToaster(
                    ["Messages.MSG_ERROR_CARICAMENTOFILE"],
                    null,
                    toasterConfig.types.critical
                );
            } else if (file.size > dimensioneMassimaFile) {
                this.props.showSpinner(false);
                this.aggiungiToaster(
                    ["Messages.MSG_ERROR_LIMIT_DIMENSIONEFILE"],
                    null,
                    toasterConfig.types.critical
                );
            } else {
                file.data = format(new Date(), "dd/MM/yyyy");
                file.stato = "inserimento";
                file.isNewFile = true;
                file.note = "";
                file.checked = true;
                this.setState({ file: file, fileDaCaricare: file });
                this.props.showSpinner(false);
            }
        } else {
            this.props.showSpinner(false);
        }
    }

    render() {
        const { t } = this.props;

        const buttons = (
            <ButtonRow
                onClickConfermaEProsegui={() => this.controlloDatiToaster("1")}
                isArchiviato={
                    (this.props.segnalazione &&
                        this.props.segnalazione.migrazione) ||
                    SessioneUtente.getInstance().ruoliUtente ===
                        Ruoli.Operatore_Laboratorio.descrizione ||
                    (this.props.segnalazioneCopia &&
                        (this.props.segnalazioneCopia.statoSegnalazione ===
                            OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                .codice ||
                            this.props.segnalazioneCopia.statoValidazione ===
                                OggettiUtili.statoValidazioneByLabel.Validata
                                    .codice))
                }
                modalTextConferma={"Buttons.confermaModifica"}
                onClickSalva={() => this.controlloDatiToaster("2")}
                back={this._back}
                nextStep={true}
            />
        );

        const modaleInvioMail = (
            <div>
                <Modale
                    classes="btnWhite"
                    soloModale={true}
                    buttonMail={true}
                    id={"confermaMail"}
                    name={"Conferma Invio Mail"}
                    typeModal="modalConsenso"
                    modalText={
                        this.state.mailInviataCorrettamente
                            ? "L’inserimento della segnalazione è stato correttamente notificato via e-mail alla Regione"
                            : "Invio e-mail non riuscito. Non è stato possibile notificare l’avvenuto inserimento"
                    }
                    text={t("Buttons.conferma")}
                    title={t("Buttons.notificaMail")}
                    textButtonOk={"OK"}
                    style={{ height: "3rem", marginTop: "1rem" }}
                    confirmFun={() =>
                        this.nextStep(
                            this.props.segnalazione,
                            this.props.segnalazioneCopia
                        )
                    }
                />
            </div>
        );

        let malattieCaricamentoPdfStep3 =
            globals["malattie-caricamento-pdf-step-3"] === "string"
                ? globals["malattie-caricamento-pdf-step-3"].split(",")
                : globals["malattie-caricamento-pdf-step-3"];

        return (
            <div
                className={
                    (this.props.segnalazione &&
                        this.props.segnalazione.migrazione) ||
                    SessioneUtente.getInstance().ruoliUtente ===
                        Ruoli.Operatore_Laboratorio.descrizione ||
                    this.props.segnalazioneCopia.statoSegnalazione ===
                        OggettiUtili.statoSegnalazioneByLabel.Archiviato
                            .codice ||
                    this.props.segnalazioneCopia.statoValidazione ===
                        OggettiUtili.statoValidazioneByLabel.Validata.codice
                        ? "visualizzazione"
                        : ""
                }
            >
                {ToasterSingleton.instance().renderToaster()}

                <fieldset
                    disabled={
                        (this.props.segnalazione &&
                            this.props.segnalazione.migrazione) ||
                        SessioneUtente.getInstance().ruoliUtente ===
                            Ruoli.Operatore_Laboratorio.descrizione ||
                        this.props.segnalazioneCopia.statoSegnalazione ===
                            OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                .codice ||
                        this.props.segnalazioneCopia.statoValidazione ===
                            OggettiUtili.statoValidazioneByLabel.Validata.codice
                    }
                >
                    <div style={{ marginTop: "1rem" }}>
                        <h6>
                            Attenzione - Per l'effettivo inserimento della
                            segnalazione è necessario che le prime tre sezioni
                            vengano compilate
                        </h6>
                        <h6>
                            Se non si conoscono le informazioni cliniche,
                            epidemiologiche e/o di laboratorio, valorizzare i
                            rispettivi campi come “Sconosciuto” o “Non
                            disponibile”. Sarà possibile aggiornare e/o
                            integrare le informazioni in un secondo momento
                        </h6>
                        <h6>{t("InfoCliniche.infoCliniche")}</h6>
                        <hr className={styles.hr} />
                        <div className="container">
                            <div className="row" style={{ paddingTop: "10px" }}>
                                <div className="col-lg-4">
                                    <p className={styles.testo}>
                                        {t("InfoCliniche.infoCliniche")}{" "}
                                        <span className={styles.mandatoryColor}>
                                            *
                                        </span>
                                    </p>
                                </div>
                                <div className="col-lg-3">
                                    <Select
                                        id={"infoCliniche"}
                                        value={
                                            this.state.infoCliniche
                                                .informazioniCliniche
                                        }
                                        onChange={this.handleChangeInfoCliniche}
                                        disabled={
                                            this.state.listaInfoCliniche
                                                .length === 0
                                        }
                                        functionMap={statiIstanza.map(
                                            (oggetto) => {
                                                return (
                                                    <option
                                                        value={oggetto.code}
                                                    >
                                                        {oggetto.displayName}
                                                    </option>
                                                );
                                            }
                                        )}
                                    ></Select>
                                </div>
                            </div>
                            {this.state.listaInfoCliniche.length > 0
                                ? this.state.boxesClinica
                                : ""}
                            {this.props.segnalazioneCopia.malattia ===
                            "0578" ? (
                                <div
                                    className="row"
                                    style={{ paddingTop: "10px" }}
                                >
                                    <div className="col-lg-4">
                                        <p className={styles.testo}>
                                            {this.props.t("InfoCliniche.note")}
                                        </p>
                                    </div>
                                    <div className="col-lg-5">
                                        <Input
                                            placeholder="Campo a testo libero"
                                            type={"textarea"}
                                            id={"note"}
                                            disabled={
                                                this.state.infoCliniche &&
                                                this.state.infoCliniche
                                                    .informazioniCliniche !==
                                                    "1"
                                            }
                                            value={this.state.infoCliniche.note}
                                            onChange={this.riceviValoreNote}
                                            field={"note"}
                                            onValidate={
                                                this.state.infoCliniche.note
                                                    ? this.state.infoCliniche.note.startsWith(
                                                          " "
                                                      )
                                                        ? 1
                                                        : 2
                                                    : 2
                                            } /// onValidate: 1 errore,  altro valore ok
                                            errorMessage={
                                                "Campo Note non valido"
                                            }
                                        />
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                    <div style={{ marginTop: "1rem" }}>
                        <h6>{t("InfoEpidemiologiche.infoEpidemiologiche")}</h6>
                        <hr className={styles.hr} />
                        <div className="container">
                            <div className="row" style={{ paddingTop: "10px" }}>
                                <div className="col-lg-4">
                                    <p className={styles.testo}>
                                        {t(
                                            "InfoEpidemiologiche.infoEpidemiologiche"
                                        )}{" "}
                                        <span className={styles.mandatoryColor}>
                                            *
                                        </span>
                                    </p>
                                </div>
                                <div className="col-lg-3">
                                    <Select
                                        id={"infoEpidemiologiche"}
                                        value={
                                            this.state.infoEpidemiologiche
                                                .infoEpidemiologiche
                                        }
                                        onChange={
                                            this.handleChangeInfoEpidemiologiche
                                        }
                                        disabled={
                                            this.state.listaInfoEpidemiologiche
                                                .length === 0
                                        }
                                        functionMap={infoEpidemiologicheMap.map(
                                            (oggetto) => {
                                                return (
                                                    <option
                                                        value={oggetto.code}
                                                    >
                                                        {oggetto.displayName}
                                                    </option>
                                                );
                                            }
                                        )}
                                    ></Select>
                                </div>
                            </div>
                            {this.state.listaInfoEpidemiologiche.length > 0
                                ? this.state.boxesEpidem
                                : ""}
                        </div>
                    </div>
                    <div style={{ marginTop: "1rem" }}>
                        <h6>{t("InfoLaboratorio.infoLaboratorio")}</h6>
                        <hr className={styles.hr} />
                        <div className="container">
                            <div className="row" style={{ paddingTop: "10px" }}>
                                <div className="col-lg-4">
                                    <p className={styles.testo}>
                                        {t("InfoLaboratorio.infoLaboratorio")}{" "}
                                        <span className={styles.mandatoryColor}>
                                            *
                                        </span>
                                    </p>
                                </div>
                                <div className="col-lg-3">
                                    <Select   
                                        addclass={this.props.segnalazione?.integrataLIS === true || this.props.segnalazione.utenteInserimento==='LIS' || this.state.autore==='LIS'? styles.cellAzure : ''}

                                        id={"infoLaboratorio"}
                                        value={
                                            this.state.infoLaboratorio
                                                .infoLaboratorio
                                        }
                                        onChange={
                                            this.handleChangeInfoLaboratorio
                                        }
                                        disabled={
                                            this.state.listaInfoLaboratorio
                                                .length === 0
                                        }
                                        functionMap={infoLaboratorioMap.map(
                                            (oggetto) => {
                                                return (
                                                    <option
                                                        value={oggetto.code}
                                                    >
                                                        {oggetto.displayName}
                                                    </option>
                                                );
                                            }
                                        )}
                                    ></Select>
                                </div>
                            </div>
                            {this.state.listaInfoLaboratorio.length > 0 ? (
                                <div>
                                    <div
                                        className="row"
                                        style={{ paddingTop: "10px" }}
                                    >
                                        <div className="col-lg-4">
                                            <p className={styles.testo}>
                                                {t(
                                                    "InfoLaboratorio.tipoLaboratorio"
                                                )}
                                            </p>
                                        </div>
                                        <div className="col-lg-3">
                                            <Select
                                                id={"tipoLaboratorio"}
                                                addclass={this.props.segnalazione?.integrataLIS === true || this.props.segnalazione.utenteInserimento==='LIS' || this.state.autore==='LIS'? styles.cellAzure : ''}
                                                value={
                                                    this.state.infoLaboratorio
                                                        .tipoLaboratorio
                                                }
                                                disabled={
                                                    this.state
                                                        .listaInfoLaboratorio
                                                        .length <= 0 ||
                                                    this.state.infoLaboratorio
                                                        .infoLaboratorio === "2"
                                                }
                                                onChange={
                                                    this.handleChangeTipoLab
                                                }
                                                functionMap={tipoLaboratorioMap.map(
                                                    (oggetto) => {
                                                        return (
                                                            <option
                                                                value={
                                                                    oggetto.code
                                                                }
                                                            >
                                                                {
                                                                    oggetto.displayName
                                                                }
                                                            </option>
                                                        );
                                                    }
                                                )}
                                            ></Select>
                                        </div>
                                    </div>
                                    <div
                                        className="row"
                                        style={{ paddingTop: "10px" }}
                                    >
                                        <div className="col-lg-4">
                                            <p className={styles.testo}>
                                                {t(
                                                    "InfoLaboratorio.dataPrelievo"
                                                )}
                                            </p>
                                        </div>
                                        <div className="col-lg-3">
                                            <Calendar
                                                addclass={this.props.segnalazione?.integrataLIS === true || this.props.segnalazione.utenteInserimento==='LIS' || this.state.autore==='LIS'? styles.cellAzure : ''}
                                                id={"dataPrelievo"}
                                                value={
                                                    this.state.infoLaboratorio
                                                        .dataPrelievo
                                                }
                                                field={"dataPrelievo"}
                                                onChange={this.riceviValore}
                                                disabled={
                                                    this.state
                                                        .listaInfoLaboratorio
                                                        .length <= 0 ||
                                                    this.state.infoLaboratorio
                                                        .infoLaboratorio === "2"
                                                }
                                                errorMessage={
                                                    this.state.infoLaboratorio
                                                        .dataPrelievo &&
                                                    Utils.isDateInValid(
                                                        this.state
                                                            .infoLaboratorio
                                                            .dataPrelievo
                                                    )
                                                        ? "Data non valida"
                                                        : ""
                                                }
                                                error={
                                                    Utils.isDateInValid(
                                                        Utils.transformDateForBackend(
                                                            this.state
                                                                .infoLaboratorio
                                                                .dataPrelievo
                                                        ),
                                                        "-"
                                                    ) &&
                                                    this.state.infoLaboratorio
                                                        .dataPrelievo !== ""
                                                }
                                            ></Calendar>
                                        </div>
                                    </div>
                                    <div
                                        className="row"
                                        style={{ paddingTop: "10px" }}
                                    >
                                        <div className="col-lg-4">
                                            <p className={styles.testo}>
                                                {t("InfoLaboratorio.dataEsame")}
                                            </p>
                                        </div>
                                        <div className="col-lg-3">
                                            <Calendar
                                                id={"dataEsame"}
                                                addclass={this.props.segnalazione?.integrataLIS === true || this.props.segnalazione.utenteInserimento==='LIS' || this.state.autore==='LIS'? styles.cellAzure : ''}
                                                value={
                                                    this.state.infoLaboratorio
                                                        .dataEsame
                                                }
                                                field={"dataEsame"}
                                                onChange={this.riceviValore}
                                                disabled={
                                                    this.state
                                                        .listaInfoLaboratorio
                                                        .length <= 0 ||
                                                    this.state.infoLaboratorio
                                                        .infoLaboratorio === "2"
                                                }
                                                errorMessage={
                                                    this.state.infoLaboratorio
                                                        .dataEsame &&
                                                    Utils.isDateInValid(
                                                        this.state
                                                            .infoLaboratorio
                                                            .dataEsame
                                                    )
                                                        ? "Data non valida"
                                                        : ""
                                                }
                                                error={
                                                    Utils.isDateInValid(
                                                        Utils.transformDateForBackend(
                                                            this.state
                                                                .infoLaboratorio
                                                                .dataEsame
                                                        ),
                                                        "-"
                                                    ) &&
                                                    this.state.infoLaboratorio
                                                        .dataEsame !== ""
                                                }
                                            ></Calendar>
                                        </div>
                                    </div>
                                    {this.state.boxesLab}
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                    <div className="row" style={{ paddingTop: "2rem" }}>
                        <div className="col-lg-12">
                            <div className={styles.mandatoryColor}>
                                *Campo obbligatorio
                            </div>
                        </div>
                    </div>
                </fieldset>
                {malattieCaricamentoPdfStep3.includes(
                    this.props.segnalazioneCopia.malattia
                ) &&
                !this.state.fileCaricato &&
                !this.state.fileDaCaricare ? (
                    <div className="row justify-content-center">
                        <label
                            className="btnWhite"
                            style={{ height: "3rem", alignItems: "center" }}
                        >
                            <input
                                type="file"
                                onChange={this.caricaPdf}
                                style={{ display: "none" }}
                                accept="application/pdf"
                            />
                            <p style={{ height: "3rem", marginTop: "1rem" }}>
                                {t("InfoCliniche.caricaAllegato")}
                            </p>
                        </label>
                    </div>
                ) : (
                    malattieCaricamentoPdfStep3.includes(
                        this.props.segnalazioneCopia.malattia
                    ) && (
                        <TableAllegatoTossinfezione
                            file={
                                this.state.fileDaCaricare?.isNewFile
                                    ? this.state.fileDaCaricare
                                    : this.state.fileCaricato?.stato !==
                                      "eliminazione"
                                    ? this.state.fileCaricato
                                    : {}
                            }
                            isNewFile={!!this.state.fileCaricato?.id}
                            segnalazioneCopia={this.props.segnalazioneCopia}
                            showSpinner={this.props.showSpinner}
                            setStatePadre={this.setStatePadre}
                        />
                    )
                )}
                <div>
                    {buttons}
                    {modaleInvioMail}
                </div>
            </div>
        );
    }
}

export default withTranslation("common")(InfoCliniche);
